export default function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-900">
          Si è verificato un errore
        </h1>
        <p className="mt-2 text-gray-600">
          Ci scusiamo per l'inconveniente. Riprova ricaricando la pagina.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-6 rounded-lg bg-green-600 px-4 py-2 text-white hover:bg-green-700"
        >
          Ricarica pagina
        </button>
      </div>
    </div>
  );
}
